module.exports = __webpack_public_path__ + "static/img/no-register.430e9803.png";